import React from 'react'
import AppDrawer from '@components/Sidebar/AppDrawer'
import Footer from '@components/organisms/Footer'
import Navigation from '@components/organisms/Navigation'
import { CompanyInfo } from '@containers/Company/Info'
import { initializeApollo } from '@graphql/apolloClient'
import {
  GetCompanyInfoDocument,
  GetCompanyInfoQuery,
  GetCompanyInfoQueryVariables,
  GetCompaniesDocument,
  GetCompaniesQuery,
  GetCompaniesQueryVariables,
  OrderBy,
} from '@services/cloud/client'

export default function CompanyInfoPage() {
  return (
    <>
      <AppDrawer>
        <CompanyInfo />
        <Footer />
        <Navigation />
      </AppDrawer>
    </>
  )
}

export async function getStaticProps(context: any) {
  const apolloClient = initializeApollo()

  const companyInfoData = await apolloClient.query<
    GetCompanyInfoQuery,
    GetCompanyInfoQueryVariables
  >({
    query: GetCompanyInfoDocument,
    variables: {
      args: {
        companyId: context.params.id as string,
      },
    },
  })

  const nextSeoValues = {
    title: `${companyInfoData?.data?.company?.name} | 塗料業界に特化した総合情報サイトのCOATAZ（コーターズ ）`,
    description: companyInfoData?.data?.company?.description || '',
    canonical: `https://coataz.com/company/${companyInfoData?.data?.company?.companyId}/info`,
    openGraph: {
      url: `https://coataz.com/company/${companyInfoData?.data?.company?.companyId}/info`,
      title: `${companyInfoData?.data?.company?.name} | 塗料業界に特化した総合情報サイトのCOATAZ（コーターズ ）`,
      description: companyInfoData?.data?.company?.description || '',
    },
  }

  return {
    props: {
      initialApolloState: apolloClient.cache.extract(),
      nextSeo: nextSeoValues,
    },
    revalidate: 1,
  }
}

export async function getStaticPaths() {
  const apolloClient = initializeApollo()

  const result = await apolloClient.query<GetCompaniesQuery, GetCompaniesQueryVariables>({
    query: GetCompaniesDocument,
    variables: {
      args: {
        limit: 5000,
        skip: 0,
        orderBy: OrderBy.Desc,
      },
    },
  })

  const paths = result.data.companies.map((company: any) => ({
    params: { id: company.companyId },
  }))

  return {
    paths,
    fallback: 'blocking',
  }
}
